// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3hu_w","head":"ProcedureTableInfo_head__UJ-yV"};